import { useFetchToWabunkaAiApi } from '@/wabunka-src/common/composables/mutation/useFetchToWabunkaAiApi';
import type { ChatApiResponse, ConversationHistoryItem } from '@/wabunka-src/features/Chat/models/chatMessage';
import { chatApiResponseConverter } from '@/wabunka-src/features/Chat/models/chatMessageFactory';

export interface SendChatMessageArgs {
  message: string;
  sessionId: string;
  slug: string;
  conversationHistory: ConversationHistoryItem[];
}

/**
 * AI Chat /chat エンドポイントへメッセージを送信する mutation composable
 */
export const useSendChatMessage = () => {
  const { execute } = useFetchToWabunkaAiApi();

  const send = (args: SendChatMessageArgs): Promise<ChatApiResponse> =>
    execute<ChatApiResponse>({
      path: '/chat',
      body: { ...args },
      converter: chatApiResponseConverter,
    });

  return { send };
};
